<template>
  <v-app>
    <router-view></router-view>
    <!-- <mdl-dialog ref="errorDialog" :title="errorDialog.title">
      <p v-html="errorDialog.content"></p>
    </mdl-dialog> -->
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "app",
  components: {},
  computed: {
    ...mapState(["errorDialog"]),
  },
};
</script>

<style>
body {
  background-color: #eceff1;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-family: "Roboto", sans-serif;
  font-size: 1.2rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
  max-width: 800px;
}
</style>
